import { ModulePublishingState } from '../@types/module-publishing-state';
import Identity from '../core/security/identity';
import Role from '../core/security/role';

export const hasAccessToModule = (identity: Identity, publishingState: ModulePublishingState, moduleId: string) => {
  if (
    identity.hasAnyRole([Role.SYSADMIN, Role.PRODUCTION, Role.EDITOR, Role.PUBLISHER]) ||
    identity.author_modules.includes(moduleId)
  ) {
    return true;
  }
  return !(publishingState === 'preview' && !identity.roles.includes(Role.SALES));
};
